/* eslint-disable react/no-multi-comp */
import React from 'react';

// import CaretUpSolid from '@/components/commons/icons/CaretUpSolid';
// import CaretDownSolid from '@/components/commons/icons/CaretDownSolid';

import { type UnifiedContactStats } from '@/components/my-sixty';

interface Props {
    readonly data: UnifiedContactStats;
}

function StatCard({
    title,
    /* icon, subtitle, */
    textColor,
    bgColor,
    value,
}) {
    return (
        <div className="flex items-center justify-start shadow-md bg-cirrusWhite h-[75px] w-[250px] md:w-[350px] rounded-lg mb-4">
            <div style={{ backgroundColor: bgColor }} className="flex items-center justify-center w-[30px] md:w-[88px] h-[75px] mr-2 sm:mr-4 rounded-l-lg shadow-md px-6 lg:px-0 ">
                <p className={`text-[24px] md:text-[36px] text-${textColor} font-bold`}>{value || 0}</p>
            </div>
            <div className="mr-0 sm:mr-4">
                <p className="font-semibold flex-wrap">{title}</p>
                {/* <div className="flex items-center justify-start">
                    <div className="mr-1">
                        {icon}
                    </div>
                    <p className="text-[14px] font-medium flex-wrap">
                        {subtitle}
                    </p>
                </div> */}
            </div>
        </div>
    );
}

function Statistics({ data }: Props) {
    // const labels = [
    //     {
    //         key: 'closest',
    //         title: 'Closest contacts',
    //         icon: <CaretUpSolid className="w-[12px]" />,
    //         subtitle: '5% change last 7 days',
    //         textColor: 'cirrusWhite',
    //         bgColor: '#434f54',
    //     },
    //     {
    //         key: 'medium',
    //         title: 'Medium contacts',
    //         icon: <CaretDownSolid className="w-[12px]" />,
    //         subtitle: '11% change last 7 days',
    //         textColor: 'cleanSlate',
    //         bgColor: '#a5bec7',
    //     },
    //     {
    //         key: 'distant',
    //         title: 'Distant contacts',
    //         icon: <CaretUpSolid className="w-[12px]" />,
    //         subtitle: '8% change last 7 days',
    //         textColor: 'cleanSlate',
    //         bgColor: '#ecf7f9',
    //     },
    //     {
    //         key: 'new',
    //         title: 'New contacts',
    //         icon: <CaretUpSolid className="w-[12px]" />,
    //         subtitle: '2% change last 7 days',
    //         textColor: 'cleanSlate',
    //         bgColor: '#f9fafb',
    //     },
    // ];

    if (!data) {
        return null;
    }

    return (
        <div className="flex flex-col items-start justify-center pt-10 pb-2">
            <StatCard title="Closest contacts" textColor="cirrusWhite" bgColor="#434f54" value={data[0]} />
            <StatCard title="Medium contacts" textColor="cleanSlate" bgColor="#a5bec7" value={data[1]} />
            <StatCard title="Distant contacts" textColor="cleanSlate" bgColor="#ecf7f9" value={data[2]} />
            <StatCard title="New contacts" textColor="cleanSlate" bgColor="#f9fafb" value={data.newContacts} />
        </div>
    );
}

export default Statistics;
